import {IPatient} from 'app/shared/model/patient.model';
import {IPatientCase} from 'app/shared/model/patient-case.model';
import {IVillage} from 'app/shared/model/village.model';
import {IHealthcareFacility} from 'app/shared/model/healthcare-facility.model';
import axios from 'axios';
import {FAILURE, REQUEST, SUCCESS} from 'app/shared/reducers/action-type.util';
import {ICrudPutAction} from 'react-jhipster';

export const ACTION_TYPES = {
  SET_REGISTRATION_DATA: 'registration/SET_REGISTRATION_DATA',
  SET_CURRENT_STEP: 'registration/SET_CURRENT_STEP',
  RESET_REGISTRATION: 'registration/RESET_REGISTRATION',
  SAVE_REGISTRATION_DATA: 'registration/SAVE_REGISTRATION_DATA',
};

export interface RegistrationEntity {
  countryId: any;
  locationType: any;
  babySymptomsIds: string[];
  motherSymptomsIds: string[];
  patient: IPatient | null;
  healthcareFacilityId: any;
  villageId: any;
  village: IVillage | null;
  healthcareFacility: IHealthcareFacility | null;
  patientCase: IPatientCase | null;
}

// To prevent state mutation
const getInitialState = () => ({
  entity: {
    countryId: null,
    locationType: null,
    babySymptomsIds: [] as string[],
    motherSymptomsIds: [] as string[],
    patient: null as IPatient,
    healthcareFacilityId: null,
    villageId: null,
    village: null as IVillage,
    healthcareFacility: null as IHealthcareFacility,
    patientCase: null as IPatientCase,
  } as RegistrationEntity,
  currentStep: 1,
  updating: false,
  updatingSuccess: false,
  errorMessage: null,
});

// Initial State
const initialState = getInitialState();

export type RegistrationState = Readonly<typeof initialState>;

// Reducer
export default (state: RegistrationState = initialState, action: any): RegistrationState => {
  switch (action.type) {
    case ACTION_TYPES.SET_REGISTRATION_DATA:
      return {
        ...state,
        entity: {
          ...state.entity,
          ...action.payload,
        },
      };
    case ACTION_TYPES.SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    case ACTION_TYPES.RESET_REGISTRATION:
      return getInitialState();
    case REQUEST(ACTION_TYPES.SAVE_REGISTRATION_DATA):
      return {
        ...state,
        updating: true,
        updatingSuccess: false,
        errorMessage: null,
      };
    case SUCCESS(ACTION_TYPES.SAVE_REGISTRATION_DATA):
      return {
        ...state,
        updating: false,
        updatingSuccess: true,
      };
    case FAILURE(ACTION_TYPES.SAVE_REGISTRATION_DATA):
      return {
        ...state,
        updating: false,
        updatingSuccess: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};

// Action Creators
export const setRegistrationData = (data: Partial<RegistrationEntity>) => ({
  type: ACTION_TYPES.SET_REGISTRATION_DATA,
  payload: data,
});

export const setCurrentStep = (step: number) => ({
  type: ACTION_TYPES.SET_CURRENT_STEP,
  payload: step,
});

export const saveRegistrationData: ICrudPutAction<RegistrationEntity> = entity => async dispatch => {
  if (!entity.patientCase) {
    return Promise.reject('Patient case data is required');
  }

  return await dispatch({
    type: ACTION_TYPES.SAVE_REGISTRATION_DATA,
    payload: axios.post('api/patient-case-with-journey', entity),
  });
};

export const resetRegistration = () => dispatch => {
  return dispatch({
    type: ACTION_TYPES.RESET_REGISTRATION,
  });
};
